export function defaultDataAcessor(item: any, sortHeaderId: string) {
  if (typeof item[sortHeaderId] === 'string') {
    return item[sortHeaderId].toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  return item[sortHeaderId];

}
